import React, { useEffect, useRef } from "react";
import "./index.scss";
import logo from "../../assets/img/logo.png";
const Banner = (props) => {
  const banner = useRef();
  useEffect(() => {
    const height = banner.current.scrollHeight;
    // console.log(props);
    props.onHeight(height);
  }, []);
  return (
    <div className="Banner" ref={banner}>
      <div className="Img">
        <img src={logo} alt="思客讲堂·党校公开课(第三季)" />
      </div>
    </div>
  );
};

export default Banner;
